export default "__VITE_ASSET__CqwMoMYY__"